import { SvRisikoFrageFacadeBase } from '@mng/vpms-sv';

export interface ISvFragenIds {
  [id: string]: string;
}

/**
 * Definitionen von Fragen die vom "generischen" Rendering ausgenommen werden
 */
export interface ISvFragenGruppenDefinition {
  title: string;
  fragenIds: string[];
}

export interface ISvFragenContainer<T extends SvRisikoFrageFacadeBase> extends ISvFragenGruppenDefinition {
  fragen: T[];
}

export const fremdversicherungIds: ISvFragenIds = {
  FREMDVERSICHERUNG_BESTEHT_FREMDVERSICHERUNG: '1086',
  FREMDVERSICHERUNG_VERSICHERUNGSANSTALT: '1069',
  FREMDVERSICHERUNG_STATUS: '1070',
  FREMDVERSICHERUNG_VERSICHERUNGSSUMME: '1071',
  FREMDVERSICHERUNG_GRUND: '1072',
  FREMDVERSICHERUNG_ART: '1073',
  FREMDVERSICHERUNG_ANTRAG: '1074',
  FREMDVERSICHERUNG_POLIZZENNR: '1075',
  FREMDVERSICHERUNG_ABLAUFDATUM: '1076'
};

export const fremdVersicherungsFragen: ISvFragenGruppenDefinition = {
  title: 'Fremdversicherung',
  fragenIds: [
    fremdversicherungIds.FREMDVERSICHERUNG_BESTEHT_FREMDVERSICHERUNG,
    fremdversicherungIds.FREMDVERSICHERUNG_VERSICHERUNGSANSTALT,
    fremdversicherungIds.FREMDVERSICHERUNG_STATUS,
    fremdversicherungIds.FREMDVERSICHERUNG_VERSICHERUNGSSUMME,
    fremdversicherungIds.FREMDVERSICHERUNG_GRUND,
    fremdversicherungIds.FREMDVERSICHERUNG_ART,
    fremdversicherungIds.FREMDVERSICHERUNG_ANTRAG,
    fremdversicherungIds.FREMDVERSICHERUNG_POLIZZENNR,
    fremdversicherungIds.FREMDVERSICHERUNG_ABLAUFDATUM
  ]
};

export const vinkulierungIds: ISvFragenIds = {
  VINKULIERUNG_BESTEHT_VINKULIERUNG: '1087',
  VINKULIERUNG_GLAEUBIGER: '1077',
  VINKULIERUNG_GESCHAEFTSZAHL: '1078',
  VINKULIERUNG_VINKULIERUNGSART: '1079',
  VINKULIERUNG_VINKULIERUNGSBETRAG: '1080',
  VINKULIERUNG_GRUNDBUCH: '1081',
  VINKULIERUNG_VORVERSICHERER: '1082',
  VINKULIERUNG_KATASTRALGEMEINDE: '1083',
  VINKULIERUNG_POLIZZENNUMMER: '1084',
  VINKULIERUNG_EINLAGEZAHL: '1085'
};

export const vinkulierungFragen: ISvFragenGruppenDefinition = {
  title: 'Vinkulierung',
  fragenIds: [
    vinkulierungIds.VINKULIERUNG_BESTEHT_VINKULIERUNG,
    vinkulierungIds.VINKULIERUNG_GLAEUBIGER,
    vinkulierungIds.VINKULIERUNG_GESCHAEFTSZAHL,
    vinkulierungIds.VINKULIERUNG_VINKULIERUNGSART,
    vinkulierungIds.VINKULIERUNG_VINKULIERUNGSBETRAG,
    vinkulierungIds.VINKULIERUNG_GRUNDBUCH,
    vinkulierungIds.VINKULIERUNG_VORVERSICHERER,
    vinkulierungIds.VINKULIERUNG_KATASTRALGEMEINDE,
    vinkulierungIds.VINKULIERUNG_POLIZZENNUMMER,
    vinkulierungIds.VINKULIERUNG_EINLAGEZAHL
  ]
};

export function filterRisikofragen<T extends SvRisikoFrageFacadeBase>(
  fragen: T[],
  ...gruppenDefinition: ISvFragenGruppenDefinition[]
): T[] {
  const fragenIds: string[] = gruppenDefinition.flatMap((container) => container.fragenIds);
  return fragen.filter((frage) => !fragenIds.includes(frage.id));
}

function getFragenForContainer<T extends SvRisikoFrageFacadeBase>(
  fragen: T[],
  gruppenDefinition: ISvFragenGruppenDefinition
): T[] {
  return fragen.filter((frage) => gruppenDefinition.fragenIds.includes(frage.id));
}

export function getFragenContainer<T extends SvRisikoFrageFacadeBase>(
  fragen: T[],
  gruppenDefinition: ISvFragenGruppenDefinition
): ISvFragenContainer<T> {
  return { ...gruppenDefinition, fragen: getFragenForContainer(fragen, gruppenDefinition) };
}
